/**
 * @file 常量
 */



// 单位类型
export const unitType = (() => {

    const jin = 'jin', // 斤
        kg = 'kg'; // 公斤
    return {
        [jin]: jin,
        [kg]: kg,
    }
})();



// WEBPACK FOOTER //
// ./src/utils/constant.js